﻿package com.mgacreative.hotelru.feature.hotel.router

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow

sealed class AppScreen {
    object Auth : AppScreen()
    object Dashboard : AppScreen() // Super Admin
    object HotelMain : AppScreen() // Hotel Owner, Reception, etc.
}

class AppRouter {
    private val _currentScreen = MutableStateFlow<AppScreen>(AppScreen.Auth)
    val currentScreen: StateFlow<AppScreen> = _currentScreen.asStateFlow()

    fun navigateTo(screen: AppScreen) {
        _currentScreen.value = screen
    }
}

